module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-27-1a00fc5d3ae8411d1286eefc387ed687.jpg";